import { writable } from 'svelte/store';

export const appStore = writable({
  loading: false,
  extensionInstalled: false
});
